import {
  Reactive1jy75v4li6ldv as Reactive,
  Listenable3m4zqvjcbvczy as Listenable,
} from '../core/coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../core/abstracts.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DebounceReactiveClass;
function DebounceReactive() {
  if (DebounceReactiveClass === VOID) {
    class $ {
      constructor(source, scope, duration) {
        this.$$delegate_0__1 = DebounceListenable().new_com_lightningkite_reactive_extensions_DebounceListenable_mfxu1z_k$(source, scope, duration);
        this.source_1 = source;
        this.scope_1 = scope;
        this.duration_1 = duration;
      }
      get_state_wc71uu_k$() {
        return this.source_1.get_state_wc71uu_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.$$delegate_0__1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.$$delegate_0__1.beginUse_omrbby_k$();
      }
    }
    initMetadataForClass($, 'DebounceReactive', VOID, VOID, [Reactive(), Listenable()]);
    DebounceReactiveClass = $;
  }
  return DebounceReactiveClass;
}
function DebounceListenable$activate$lambda$slambda(this$0, $n) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(this$0.duration_1, $completion);
    var tmp;
    if ($n === this$0.changeCount_1) {
      this$0.invokeAllListeners_uusj2y_k$();
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 1);
}
var DebounceListenableClass;
function DebounceListenable() {
  if (DebounceListenableClass === VOID) {
    class $ extends BaseListenable() {
      constructor(source, scope, duration) {
        return new.target.new_com_lightningkite_reactive_extensions_DebounceListenable_mfxu1z_k$(source, scope, duration);
      }
      static new_com_lightningkite_reactive_extensions_DebounceListenable_mfxu1z_k$(source, scope, duration) {
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$();
        $this.source_1 = source;
        $this.scope_1 = scope;
        $this.duration_1 = duration;
        $this.changeCount_1 = 0;
        $this.releaseListener_1 = null;
        return $this;
      }
      activate_yijg9v_k$() {
        var tmp = this;
        tmp.releaseListener_1 = this.source_1.addListener_6y9mct_k$(() => {
          this.changeCount_1 = this.changeCount_1 + 1 | 0;
          var n = this.changeCount_1;
          launch(this.scope_1, VOID, VOID, DebounceListenable$activate$lambda$slambda(this, n));
          return Unit_instance;
        });
      }
      deactivate_pmdz1g_k$() {
        this.changeCount_1 = this.changeCount_1 + 1 | 0;
        var tmp0_safe_receiver = this.releaseListener_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.releaseListener_1 = null;
      }
    }
    initMetadataForClass($, 'DebounceListenable');
    DebounceListenableClass = $;
  }
  return DebounceListenableClass;
}
function debounce(_this__u8e3s4, duration, scope) {
  return new (DebounceReactive())(_this__u8e3s4, scope, duration);
}
//region block: exports
export {
  DebounceReactive as DebounceReactive1svue0nfgksym,
  debounce as debounce3vjzafx7e7d30,
};
//endregion

//# sourceMappingURL=debounce.mjs.map
